const adminDashboard = {
  newRequestRoute: {
    invalidProjectId: "Ógilt auðkenni verkefnis",
  },
  usersView: {
    loading: "Hleð notendum...",
    heading: "Notendastjórnun",
    totalUsers: "Fjöldi notenda: {{count}}",
    noUsersFound: "Engir notendur fundust",
    sections: {
      allOrgUsers: "Allir notendur stofnunar",
      yourProjectUsers: "Notendur í þínum verkefnum",
      otherOrgUsers: "Aðrir notendur stofnunar",
    },
    errors: {
      loadFailed: "Ekki tókst að sækja gögn",
      disable2faFailed: "Ekki tókst að slökkva á tvíþátta auðkenningu",
      promotePiFailed: "Ekki tókst að gera notanda að PI",
      revokePiFailed: "Ekki tókst að afturkalla PI-hlutverk",
      addToProjectFailed: "Ekki tókst að bæta notanda við verkefni",
      removeFromProjectFailed: "Ekki tókst að fjarlægja notanda úr verkefni",
    },
    success: {
      disable2fa:
        "Slökkt var á tvíþátta auðkenningu. Notandi þarf að setja hana upp aftur við næstu innskráningu.",
      promotePi: "Notandi gerður að PI.",
      revokePi:
        "PI-hlutverk afturkallað. Notandi færður niður í rannsakanda og fjarlægður sem PI úr virkum verkefnum sínum.",
      addToProject: "Notanda var bætt við verkefnið.",
      removeFromProject: "Notandi var fjarlægður úr verkefninu.",
    },
  },
  projectsView: {
    loading: "Hleð verkefnum...",
    loadFailed: "Ekki tókst að sækja verkefni",
    heading: "Verkefnastjórnun",
    projectCount_one: "{{count}} verkefni",
    projectCount_other: "{{count}} verkefni",
    archivedSuffix_one: ", {{count}} geymt",
    archivedSuffix_other: ", {{count}} geymd",
    showArchived: "Sýna geymd",
    newProject: "Nýtt verkefni",
    noProjectsArchived: "Engin verkefni ennþá",
    noProjectsActive:
      "Engin virk verkefni — hakaðu við „Sýna geymd“ ef þú ert að leita að geymdu verkefni",
    owner: "Eigandi",
    status: {
      archived: "Geymt",
      active: "Virkt",
      inactive: "Óvirkt",
    },
  },
  requestsView: {
    loading: "Hleð gagnabeiðnum...",
    loadFailed: "Ekki tókst að sækja gagnabeiðnir",
    heading: "Beiðnir til afgreiðslu",
    subtitle: "Gagnabeiðnir og beiðnir um aðgang að gagnasöfnum í verkefnum sem þú stýrir.",
    ownRequestsBefore: "Þínar eigin beiðnir eru undir ",
    ownRequestsLink: "Beiðnirnar þínar",
    ownRequestsAfter: ".",
    newRequest: "+ Ný beiðni",
    noRequestsFound: "Engar beiðnir bíða afgreiðslu hjá þér.",
  },
};

export default adminDashboard;
